/* ============================================================
   JUSTYOL — Help pages JS: FAQ (search + accordion) + Suivi de
   commande sans compte (mode WhatsApp / mode démo timeline)
   ============================================================ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function isArabic() {
    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    return lang.indexOf('ar') === 0 || document.documentElement.dir === 'rtl';
  }

  function waNumber(root) {
    var n = root.getAttribute('data-wa') || window.JY_WA || '';
    return String(n).replace(/\D/g, '');
  }

  /* ---------------- FAQ ---------------- */
  function initFaq(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-jy-faq-item]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-jy-faq-group]'));
    var empty = root.querySelector('[data-jy-faq-empty]');
    var input = root.querySelector('[data-jy-faq-search]');

    function setOpen(item, on) {
      var btn = item.querySelector('.jy-faq-q');
      var ans = item.querySelector('.jy-faq-a');
      item.classList.toggle('on', on);
      if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (ans) ans.hidden = !on;
    }

    items.forEach(function (item) {
      var btn = item.querySelector('.jy-faq-q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var wasOn = item.classList.contains('on');
        items.forEach(function (other) {
          setOpen(other, false);
        });
        if (!wasOn) setOpen(item, true);
      });
    });

    if (input) {
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        var anyVisible = false;
        items.forEach(function (item) {
          var hay = item.getAttribute('data-search') || '';
          var show = !q || hay.indexOf(q) !== -1;
          item.hidden = !show;
          if (show) anyVisible = true;
        });
        groups.forEach(function (group) {
          var visible = group.querySelectorAll('[data-jy-faq-item]:not([hidden])').length > 0;
          group.hidden = !visible;
        });
        if (empty) empty.hidden = anyVisible;
      });
    }
  }

  /* ---------------- Track order ---------------- */
  function initTrack(root) {
    var form = root.querySelector('[data-jy-track-form]');
    if (!form) return;
    var mode = root.getAttribute('data-mode') || 'whatsapp';
    var numEl = root.querySelector('[data-jy-track-num]');
    var phoneEl = root.querySelector('[data-jy-track-phone]');
    var goBtn = root.querySelector('[data-jy-track-go]');
    var result = root.querySelector('[data-jy-track-result]');
    var ar = isArabic();
    var wa = waNumber(root);

    function valid() {
      var n = numEl ? numEl.value.trim() : '';
      var p = phoneEl ? phoneEl.value.replace(/\D/g, '') : '';
      return n.length >= 4 && p.length >= 9;
    }

    function orderId() {
      var clean = numEl.value.trim().toUpperCase().replace(/^#/, '');
      return clean.indexOf('JY-') === 0 ? clean : 'JY-' + clean;
    }

    function refresh() {
      if (goBtn) goBtn.setAttribute('aria-disabled', valid() ? 'false' : 'true');
    }
    [numEl, phoneEl].forEach(function (el) {
      if (el) el.addEventListener('input', refresh);
    });
    refresh();

    function openWhatsApp(id, phone) {
      var msg = ar
        ? 'تتبع الطلب ' + id + ' — ' + phone
        : 'Suivi commande ' + id + ' — ' + phone;
      window.open('https://wa.me/' + wa + '?text=' + encodeURIComponent(msg), '_blank', 'noopener');
    }

    function showDemo(id) {
      if (!result) return;
      // demo: known ids resolve as delivered, others show an in-transit order
      var step = /317|129/.test(id) ? 4 : 3;
      var idEl = result.querySelector('[data-jy-track-id]');
      if (idEl) idEl.textContent = id;

      var steps = Array.prototype.slice.call(result.querySelectorAll('[data-jy-step]'));
      steps.forEach(function (el, i) {
        el.classList.toggle('done', i <= step);
        el.classList.toggle('now', i === step);
      });

      var status = result.querySelector('[data-jy-track-status]');
      if (status) {
        var label = steps[step] ? steps[step].querySelector('small') : null;
        status.textContent = label ? label.textContent : '';
        status.classList.toggle('jy-track-status--done', step === 4);
      }

      var eta = result.querySelector('[data-jy-track-eta]');
      var done = result.querySelector('[data-jy-track-done]');
      if (eta) eta.hidden = step === 4;
      if (done) done.hidden = step < 4;

      var help = result.querySelector('[data-jy-track-help]');
      if (help && wa) {
        var msg = ar
          ? 'السلام، استفسار عن الطلب ' + id
          : 'Bonjour, question sur la commande ' + id;
        help.href = 'https://wa.me/' + wa + '?text=' + encodeURIComponent(msg);
      }

      result.hidden = false;
      result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!valid()) {
        if (numEl && numEl.value.trim().length < 4) numEl.focus();
        else if (phoneEl) phoneEl.focus();
        return;
      }
      var id = orderId();
      if (mode === 'demo') {
        showDemo(id);
      } else {
        openWhatsApp(id, phoneEl.value.trim());
      }
    });
  }

  ready(function () {
    Array.prototype.slice.call(document.querySelectorAll('[data-jy-faq]')).forEach(initFaq);
    Array.prototype.slice.call(document.querySelectorAll('[data-jy-track]')).forEach(initTrack);
  });

  // Re-init when sections are re-rendered in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var faq = e.target.querySelector('[data-jy-faq]');
    if (faq) initFaq(faq);
    var track = e.target.querySelector('[data-jy-track]');
    if (track) initTrack(track);
  });
})();
